import { ModuleWithProviders, NgModule }   from '@angular/core';
import { CommonModule }                    from '@angular/common';
import { TranslateModule }                 from '@ngx-translate/core';
import { CsAdvancedDropdownComponent }     from './advanced-dropdown.component';
import { CsAdvancedDropdownItemComponent } from './advanced-dropdown-item.component';
import { MatTooltipModule }                from '@angular/material/tooltip';
import { ScrollingModule }                 from '@angular/cdk/scrolling';
import { OverlayModule }                   from '@angular/cdk/overlay';
import { ComponentTranslationLoaderService, CsCommonPipesModule } from '@cs/common';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
        ScrollingModule,
        OverlayModule,
        TranslateModule,
        CsCommonPipesModule
    ],
    declarations: [CsAdvancedDropdownComponent, CsAdvancedDropdownItemComponent],
    exports: [CsAdvancedDropdownComponent, CsAdvancedDropdownItemComponent]
})
export class CsAdvancedDropdownModule {
	static forRoot(): ModuleWithProviders<CsAdvancedDropdownModule> {
		return {ngModule: CsAdvancedDropdownModule};
	}

	constructor(loader: ComponentTranslationLoaderService) {
		loader.registerComponentModule('advanced-dropdown');
	}
}
